export function isMac() {
  return navigator.userAgent.includes('Mac')
}
